import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, RouterLink],
})
export class NotFoundComponent implements OnInit {
  ngOnInit(): void {
    throw new Error(`The user got to the 404 page. Invalid URL: ${document.location.href}`);
  }
}
